import {
  Box,
  Chip,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { ExeReportHistoryStatus, StatusStyles } from "../../components-new/layout/constants";
import { formatDuration } from "../../../src/utils/timeFormatter.js";
import { AuthedFileLink } from "../../components-new/common";

const StyledTableCell = styled(TableCell)`
  color: #232d3d;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #e2e6f3;
`;

const StyledTableBodyCell = styled(TableCell)`
  padding: 8px 20px;
  border-bottom: 1px solid #eee;
  p {
    color: #2b3539;
    font-size: 16px;
    font-weight: 500;
    padding-right: 15px;
    min-width: 60px;
  }
`;

const StatusPill = styled(Chip)(({ type }) => ({
  minWidth: "82px",
  padding: "8px 10px",
  gap: "10px",
  ...(StatusStyles[type] || {}),
  "& span": {
    textTransform: "capitalize",
  },
}));
const CurrentExecutionTable = ({ data, onRowClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRowClick = (item) => {
    if (onRowClick) {
      onRowClick(item);
    }
  };

  return (
    <Box flex={1}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Test Case</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Run By</StyledTableCell>
              <StyledTableCell>Started</StyledTableCell>
              <StyledTableCell>Duration</StyledTableCell>
              <StyledTableCell>Browser</StyledTableCell>
              <StyledTableCell>Error Code</StyledTableCell>
              <StyledTableCell>Log File</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleRowClick(item)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <StyledTableBodyCell>{item.testcase || "-"}</StyledTableBodyCell>
                    <StyledTableBodyCell>
                      <StatusPill
                        label={ExeReportHistoryStatus[item.Status] || item.Status}
                        type={item.Status}
                      />
                    </StyledTableBodyCell>
                    <StyledTableBodyCell>{item.Executed_By || "-"}</StyledTableBodyCell>
                    <StyledTableBodyCell>
                      {item.Executed_Date
                        ? new Date(item.Executed_Date).toLocaleString()
                        : "-"}
                    </StyledTableBodyCell>
                    <StyledTableBodyCell>
                      {formatDuration(item.Duration || 0)}
                    </StyledTableBodyCell>
                    <StyledTableBodyCell>{item.Browser || "-"}</StyledTableBodyCell>
                    <StyledTableBodyCell>
                      {item.issuetype && (
                        <Chip
                          size="small"
                          label={item.issuetype}
                          color={item.issuetype === "E0000" ? "error" : "warning"}
                        />
                      )}
                    </StyledTableBodyCell>
                    <StyledTableBodyCell>
                      {item.logfile && (
                        <AuthedFileLink
                          url={item.logfile}
                          filename={`${item.testcase || "test-case"}.log`}
                        >
                          View Log
                        </AuthedFileLink>
                      )}
                    </StyledTableBodyCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <StyledTableBodyCell align="center" colSpan={8}>
                  No concurrent executions found
                </StyledTableBodyCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={data?.length || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default CurrentExecutionTable;
